import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)

    return (
        <details class="accordion group ns-px-4 ns-p-l-0 " is="accordion-disclosure" aria-expanded={`${active ? 'true' : 'false'}`}>
        <summary>
        <span class="accordion__toggle font-serif text-sm uppercase tracking-wide">
            <span class="text-with-icon gap-4">{facet.name}</span>
            <svg aria-hidden="true" focusable="false" fill="none" width="10" class="group-expanded:rotate icon icon-chevron-down" viewBox="0 0 10 10">
                <path d="m1 3 4 4 4-4" stroke="currentColor" stroke-linecap="square"></path>
            </svg>
        </span>
        </summary>
        <div class="accordion__content ">
        <div class="v-stack gap-2.5">
        {facet.data?.map((value,index) => (
            value.value !== "[]" &&
            <div class="checkbox-control">
                <input id={`filter-${facet.field}-${index}`} class="dot-checkbox" type="checkbox"  value={value.value} checked={value.selected}/>
                <label htmlFor={`filter-${facet.field}-${index}`} onClick={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }} class="">{value.value.replace('["','').replace('"]','')}</label>
            </div>
        ))}
            
        </div>
        </div>
        </details>
    )
}
